module.exports = __webpack_public_path__ + "media/images/front/icons/columns-9bb829ecae053b3aa6e1fc7bfdccc4da.png";